import { ENTITY_VALUE_FILTER, ENTITY_TYPE_FILTER } from '../../const/logFilters';

function getEntityAttrsFromChunk(el) {
    let filterKey, filterValue = null;

    if (el && el.dataset) {
        if (el.dataset.filterKey === 'chunk-text') {
            filterKey = ENTITY_VALUE_FILTER;
            filterValue = el.dataset.filterValue;
        }
        if (el.dataset.filterKey === 'chunk-type') {
            filterKey = ENTITY_TYPE_FILTER;
            filterValue = el.dataset.filterValue;
        }
    }

    return { filterKey, filterValue };
}

export default getEntityAttrsFromChunk;
